<template>
  <div :class="prefix">
    <div :class="`${prefix}_content`">
      <div :class="`${prefix}_content-box`">
        <user-center
          :message="$message"
          :userInfo="userInfo"
          @success="updateUser"
          @modifyPassword="handleModifyPasswordSuccess"
        ></user-center>
      </div>
    </div>
  </div>
</template>

<script>
import UserCenter from "common/src/components/userCenter.vue";
export default {
  components: { UserCenter },
  data() {
    return {
      prefix: "user-info",
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.info;
    },
  },
  methods: {
    updateUser() {
      this.$store.dispatch("user/getUser");
    },
    async handleModifyPasswordSuccess() {
      this.$store.commit("tabView/SET_DEFAT_OPENTABS");
      await this.$store.dispatch("user/fedLogOut");
      window.location.replace(
        `${window.baseConfig.loginServeUrl}/Signout?&redirectUrl=${window.location.href}`
      );
    },
  },
};
</script>

<style lang="scss">
.user-info {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  &_content {
    padding: 20px;
    background-color: #ffffff;
    width: 70%;
    height: 100%;
    min-width: 1200px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    &-box {
      box-sizing: border-box;
      height: 100%;
      width: 500px;
      padding: 40px 0;
      .modify-password-dialog {
        background: #ffffff;
      }
      .modify-password-dialog-header {
        background: linear-gradient(90deg, #f1f1f1 0%, #f5f8fa 100%);
      }
    }
  }
}
</style>
